export enum UserStatus {
  All = '',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
